import React from 'react';

export const Watch = ({
  className,
  color,
}: {
  className?: string;
  color?: string;
}) => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="24"
      height="24"
      transform="translate(0.668945 0.5)"
      fill="white"
      fillOpacity="0.01"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.6689 18.5C8.13295 18.5 4.66995 14.24 4.66995 12.5C4.66995 10.499 8.12895 6.5 12.6699 6.5C17.0459 6.5 20.6679 10.473 20.6679 12.5C20.6679 14.24 17.2059 18.5 12.6699 18.5H12.6689ZM12.6699 4.5C7.14895 4.5 2.66895 9.341 2.66895 12.5C2.66895 15.586 7.24495 20.5 12.6689 20.5C18.0919 20.5 22.6689 15.586 22.6689 12.5C22.6689 9.341 18.1889 4.5 12.6689 4.5"
      fill={color || '#42526E'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.6459 14.484C11.5429 14.484 10.6459 13.587 10.6459 12.484C10.6459 11.381 11.5429 10.484 12.6459 10.484C13.7499 10.484 14.6459 11.381 14.6459 12.484C14.6459 13.587 13.7499 14.484 12.6459 14.484ZM12.6459 8.484C10.4399 8.484 8.64595 10.278 8.64595 12.484C8.64595 14.69 10.4399 16.484 12.6459 16.484C14.8529 16.484 16.6459 14.69 16.6459 12.484C16.6459 10.278 14.8529 8.484 12.6459 8.484Z"
      fill={color || '#42526E'}
    />
  </svg>
);
